import { emailDomainRegex, validateEmailCustomYupValidation } from "pages/mlops/ducks/utils";
import * as yup from "yup";
const QUESTION_REQUIRED_MESSAGE = "This question is required.";
const MAX_400_CHARS_MESSAGE = "This field must be at most 400 characters";
export function yupSequentialStringSchema(schemas: yup.StringSchema[]) {
    return yup.string().test(async (value, context) => {
      try {
        for (const schema of schemas) {
          // eslint-disable-next-line no-await-in-loop
          await schema.validate(value);
        }
      } catch (error: unknown) {
        const message = (error as yup.ValidationError).message;
        return context.createError({message});
      }
  
      return true;
    });
}

export const podStep1OnboardingValidations = (isSkipServerValidation?: boolean) => yup
.object({
    pod: yup.string().trim().required().matches(/^[A-Za-z]+$/, "Invalid Pod Abbreviation format.").max(150, "Pod Abbreviation must be at most 150 characters").label("Pod Abbreviation"),
    ciName: yup.string().max(150, "CI name must be at most 150 characters"),
    businessVertical: yup.string().trim().required("Business vertical is required.").max(150, "Business vertical must be at most 150 characters"),
    podAmbassadorEmail: yup.string().email().required("Pod Ambassador email is required").matches(emailDomainRegex, "Invalid email domain. Please enter a toyota email id."),
    description: yup.string().trim().required("Project Description is required.").max(400, "Project Description must be at most 400 characters"),
    architectureDiagramFile: yup.mixed().test("type", "Please provide PDF file.", (value: any) => {
        const allowedFormats = ["application/pdf"];
        return (value && value.length > 0) ? allowedFormats.includes(value[0].type) : true;
    }).test("size", "Only allow upto 200 KB", (value: any) => {
        const size = 1024 * 200
        return (value && value.length > 0) ? value[0].size <= size : true;
    }),
    podFullName:  yup.string().trim().required().matches(/^[A-Za-z ]+$/, "Invalid Pod Name format.").max(250).label("Pod Name"),
    is_wandb_onboarding_enabled: yup.boolean().required()
});

export const podStep2OnboardingValidations = yup
.object({
  projectGoals:  yup.string().trim().required(QUESTION_REQUIRED_MESSAGE).max(400, MAX_400_CHARS_MESSAGE),
  typeOfMLProblem: yup.string().trim().required(QUESTION_REQUIRED_MESSAGE).max(400, MAX_400_CHARS_MESSAGE),
  endUser: yup.string().trim().required(QUESTION_REQUIRED_MESSAGE).max(400, MAX_400_CHARS_MESSAGE),
  typeOfDataAndStorage: yup.string().trim().required(QUESTION_REQUIRED_MESSAGE).max(400, MAX_400_CHARS_MESSAGE),
  privacyAndCompliance: yup.string().trim().required(QUESTION_REQUIRED_MESSAGE).max(400, MAX_400_CHARS_MESSAGE),
  frameworksOrLibraries: yup.string().trim().required(QUESTION_REQUIRED_MESSAGE).max(400, MAX_400_CHARS_MESSAGE),
  computeRequirment: yup.string().trim().required(QUESTION_REQUIRED_MESSAGE).max(400, MAX_400_CHARS_MESSAGE),
  deploymentStrategy: yup.string().trim().required(QUESTION_REQUIRED_MESSAGE).max(400, MAX_400_CHARS_MESSAGE),
  performanceMonitor: yup.string().trim().required(QUESTION_REQUIRED_MESSAGE).max(400, MAX_400_CHARS_MESSAGE),
  usageCost: yup.string().trim().required(QUESTION_REQUIRED_MESSAGE).max(400, MAX_400_CHARS_MESSAGE),
});


export const podStep3OnboardingValidations = yup
.object({
    addUserLater: yup.bool(),
    users: yup.array()
    .of(
        yup.object().shape({
        email: yupSequentialStringSchema([
            yup.string().required("User email is required"),
            yup.string().email().matches(emailDomainRegex, "Invalid email domain. Please enter a toyota email id."),
            yup.string().test("is_valid_email", "Email Id not exist. Please enter a valid Toyota email id.", validateEmailCustomYupValidation)
        ]),
        roles: yup.array().of(yup.string().required()).required().min(1, "At least one role is required."),
        })
    )
});
